import { graphql } from "@/gql"

// Admin grid + duplicate scans: a page of contacts across all records, with the
// resolved record joined in. Ordered by value so same-value rows are adjacent,
// which is what the duplicate/clean scanners want; the browse grid re-sorts on
// the client via useGrid. Mirrors `fetchAllTimes`.
export const fetchContactsForAdmin = graphql(`
  query fetchContactsForAdmin($limit: Int!, $offset: Int!, $where: record_contacts_bool_exp) {
    contacts: record_contacts(
      where: $where
      order_by: { value: asc }
      limit: $limit
      offset: $offset
    ) {
      ...RecordContactFields
      record {
        ...RequiredRecordFields
      }
    }
    contacts_aggregate: record_contacts_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`)

// Per-contact-type totals for the admin stats row, scoped by `$where`.
export const fetchContactTypeCounts = graphql(`
  query fetchContactTypeCounts($where: record_contacts_bool_exp!) {
    email: record_contacts_aggregate(
      where: { _and: [$where, { contact_type: { _eq: "email" } }] }
    ) {
      aggregate {
        count
      }
    }
    phone: record_contacts_aggregate(
      where: { _and: [$where, { contact_type: { _eq: "phone" } }] }
    ) {
      aggregate {
        count
      }
    }
    url: record_contacts_aggregate(where: { _and: [$where, { contact_type: { _eq: "url" } }] }) {
      aggregate {
        count
      }
    }
    location: record_contacts_aggregate(
      where: { _and: [$where, { contact_type: { _eq: "location" } }] }
    ) {
      aggregate {
        count
      }
    }
  }
`)

// Match a single record's own contacts as the user types, so an inline editor
// can surface what's already on the record (and avoid duplicate adds) before
// committing a freeform value. Scoped to record + contact_type; lean
// projection (value + label only).
export const searchContactsOnRecord = graphql(`
  query searchContactsOnRecord($recordId: Int!, $value: String!, $contactType: String!) {
    contacts: record_contacts(
      where: {
        record_id: { _eq: $recordId }
        value: { _ilike: $value }
        contact_type: { _eq: $contactType }
      }
      order_by: { value: asc }
    ) {
      id
      contact_type
      value
      label
    }
  }
`)

export const searchRecordContactsByValues = graphql(`
  query searchRecordContactsByValues($values: [String!]!, $type: String!) {
    contacts: record_contacts(
      where: { value: { _in: $values }, record: { type: { _eq: $type } } }
      order_by: { created_at: desc }
    ) {
      ...RecordContactFields
      record {
        ...RecordFields
      }
    }
  }
`)
